<template>
    <v-container>
        <v-sheet v-if="flow === 'create'">
            <v-row class="main-container" justify="space-around">
                <v-col justify="space-around">
                    <v-sheet class="pa-8 rounded" elevation="18">
                        <h1 class="title">{{ "Create user for Sandbox environment" | t }}</h1>

                        <v-form v-model="company_validation">
                            <v-text-field
                                v-model="company_name"
                                :label="'Company name' | t"
                                :rules="[v => !!v || this.t('Company name is required')]"
                                placeholder="Tarkpay OÜ"
                                prepend-icon="euro_symbol"
                            />
                            <v-text-field
                                v-model="identification_code"
                                :label="'Company identification code' | t"
                                :rules="[v => !!v || this.t('Identification code is required')]"
                                placeholder="12345678"
                                prepend-icon="description"
                            />
                        </v-form>
                    </v-sheet>
                    <v-sheet class="pa-8 mt-3 rounded" elevation="18">
                        <v-form v-model="user_validation">
                            <v-text-field
                                v-model="first_name"
                                :label="'First name' | t"
                                placeholder="Tark"
                                prepend-icon="arrow_forward"
                            />
                            <v-text-field
                                v-model="last_name"
                                :label="'Last name' | t"
                                placeholder="Pay"
                                prepend-icon="arrow_forward"
                            />
                            <v-text-field
                                v-model="email"
                                :label="'Email' | t"
                                :rules="[
                                    v =>
                                        !v ||
                                        /^\w+([.+-]?\w+)*@\w+([.+-]?\w+)*(\.)\w+$/.test(v) ||
                                        this.t('E-mail must be valid')
                                ]"
                                placeholder="info@tarkpay.ee"
                                prepend-icon="arrow_forward"
                            />
                            <v-checkbox v-model="checkbox">
                                <template v-slot:label>
                                    <div>
                                        {{ "I agree with" | t }}
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <a
                                                    v-on="on"
                                                    :href="`${api_url}/public/kasutustingimused/`"
                                                    target="_blank"
                                                    @click.stop
                                                >
                                                    {{ "Terms" | t }}
                                                </a>
                                            </template>
                                            {{ `Tarkpay ${t("terms of use")}` }}
                                        </v-tooltip>
                                    </div>
                                </template>
                            </v-checkbox>
                            <p v-if="error_msg" class="mb-1 ml-1" style="color: red">{{ error_msg | t }}</p>
                            <v-btn
                                :disabled="!company_validation || !user_validation || !checkbox"
                                class="mt-2"
                                @click="(flow = 'configure_recipient_info'), (error_msg = null)"
                                >{{ "Next" | t }}
                            </v-btn>
                        </v-form>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-sheet>
        <v-sheet v-if="flow === 'configure_recipient_info'">
            <v-row class="main-container" justify="space-around">
                <v-col justify="space-around">
                    <v-sheet class="pa-8 mt-3 rounded" elevation="18">
                        <a
                            class="text-decoration-none flex-row justify-end"
                            href="#"
                            style="color: gray"
                            @click="(flow = 'create'), (error_msg = null)"
                        >
                            <v-icon>arrow_back</v-icon>
                            <span>Back</span></a
                        >
                        <h1>{{ "Configure recipient info" | t }}</h1>
                        <v-form v-model="iban_validation">
                            <div v-for="(item, index) in activeCompanyBanks" :key="`${item.bank_id}`">
                                <v-row v-if="item.name !== 'Stripe' && item.name !== 'Placet'">
                                    <v-col cols="6">
                                        <v-text-field
                                            :label="`${item.name} ${item.country} ${t('recipient IBAN')}`"
                                            :rules="[rules.ibanRule]"
                                            :value="item.recipient_iban"
                                            placeholder="EE123456789"
                                            prepend-icon="arrow_forward"
                                            @input="updateBankField($event, 'recipient_iban', index)"
                                        >
                                            <template slot="append">
                                                <v-btn
                                                    x-small
                                                    v-if="
                                                        index === 0 &&
                                                            item.recipient_iban &&
                                                            item.recipient_iban.length > 0
                                                    "
                                                    @click="applyIbanToAll(item.recipient_iban)"
                                                    >{{ t("Apply to all") }}
                                                </v-btn>
                                            </template>
                                        </v-text-field>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-text-field
                                            :label="`${item.name} ${item.country} ${t('recipient name')}`"
                                            :placeholder="item.name + ' OÜ'"
                                            :rules="[rules.required]"
                                            :value="item.recipient_name"
                                            prepend-icon="arrow_forward"
                                            @input="updateBankField($event, 'recipient_name', index)"
                                        >
                                            <template slot="append">
                                                <v-btn
                                                    x-small
                                                    v-if="
                                                        index === 0 &&
                                                            item.recipient_name &&
                                                            item.recipient_name.length > 0
                                                    "
                                                    @click="applyNameToAll(item.recipient_name)"
                                                    >{{ t("Apply to all") }}
                                                </v-btn>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-form>
                        <p v-if="error_msg" class="mb-1 ml-1" style="color: red">{{ error_msg | t }}</p>
                        <v-row style="align-items: baseline;">
                            <v-col>
                                <v-btn :disabled="!iban_validation" class="flex-row" @click="handleCreateClick()"
                                    >{{ "Create" | t }}
                                </v-btn>
                            </v-col>
                            <v-spacer />
                            <v-col :cols="1">
                                <a
                                    href="#"
                                    style="text-decoration: none; color: grey; font-size: small"
                                    @click="handleCreateClick()"
                                    >{{ "Skip" | t }}</a
                                >
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-sheet>
        <v-sheet v-if="flow === 'activation'">
            <v-row class="main-container" justify="space-around">
                <v-col justify="space-around">
                    <v-sheet class="pa-8 mt-3 rounded text-center" elevation="18">
                        <h1>{{ "Activation link sent!" | t }}</h1>
                        <p>
                            {{
                                "We've sent you an email with an activation link. If you don't see the email, check your spam folder."
                                    | t
                            }}
                        </p>
                        <p>
                            {{ "For new link" | t }}
                            <a href="#new-link" @click="handleResendActivationClick">{{ "click here" | t }}</a
                            >.
                        </p>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-sheet>
        <v-sheet v-if="flow === 'resend-done'">
            <v-row class="main-container" justify="space-around">
                <v-col justify="space-around">
                    <v-sheet class="pa-8 mt-3 rounded text-center" elevation="18">
                        <h1>{{ "New activation link sent!" | t }}</h1>
                        <p>
                            {{
                                "We've sent you again an email with an activation link. If you don't see the email, check your spam folder."
                                    | t
                            }}
                        </p>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-sheet>
    </v-container>
</template>

<script>
import settings from "@/settings";
import { mapActions, mapState } from "vuex";
import Store from "../../store";
import IBAN from "iban";

export default {
    name: "registration-view",
    data() {
        return {
            first_name: null,
            identification_code: null,
            company_name: null,
            last_name: null,
            email: null,
            iban_validation: false,
            company_validation: false,
            user_validation: false,
            checkbox: null,
            error_msg: null,
            flow: "create",
            api_url: settings.api_url,
            user_id: null,
            rules: {
                required: value => !!value || "Required.",
                ibanRule: value => {
                    return IBAN.isValid(value) || "Invalid IBAN.";
                }
            }
        };
    },
    async mounted() {
        await this.logOutCurrentUser(false);
        await this.getAvailableBanks();
    },
    computed: { ...mapState(["activeCompanyBanks"]) },
    methods: {
        ...mapActions(["registerNewUser", "logOutCurrentUser", "getAvailableBanks"]),
        async handleCreateClick() {
            this.error_msg = null;
            let payload = {
                company_name: this.company_name,
                company_identification_code: this.identification_code,
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                banks: this.activeCompanyBanks
            };
            let result = await this.registerNewUser(payload);
            if (result && result.success === 1) {
                this.flow = "activation";
                this.user_id = result.user_id;
                Store.commit("setActiveCompanyBanks", []);
            } else {
                this.error_msg = result.error_msg;
                this.flow = "create";
            }
        },
        updateBankField(value, field, index) {
            Store.commit("updateActiveCompanyBankProperty", { prop: field, value: value, index: index });
        },
        handleResendActivationClick() {
            let data = {
                id: this.user_id,
                email: this.email
            };
            Store.dispatch("resendActivationLink", data).then(result => {
                if (result && result.success === 1) this.flow = "resend-done";
            });
        },
        applyIbanToAll(iban) {
            this.activeCompanyBanks.forEach((item, index) => {
                this.updateBankField(iban, "recipient_iban", index);
            });
        },
        applyNameToAll(name) {
            this.activeCompanyBanks.forEach((item, index) => {
                this.updateBankField(name, "recipient_name", index);
            });
        }
    }
};
</script>

<style scoped></style>
